import React, { FC, MouseEvent } from "react"

interface LinkButtonProps {
    testId?: string
    className?: string
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void
    theme?: "light" | "dark"
}

/**
 * A button which looks like a link but has `onClick` instead of `to`
 */
export const LinkButton: FC<LinkButtonProps> = ({
    className,
    testId,
    onClick,
    children,
    theme = "light"
}) => {
    return (
        <button
            data-testid={testId}
            type="button"
            className={`p-0 ${
                theme === "light" ? "text-pink-500" : "text-violet"
            } no-underline hover:underline ${className ?? ""}`}
            onClick={onClick}
        >
            {children}
        </button>
    )
}
